import React from 'react';
import { buildApexCanonicalUrl } from '../lib/siteUrls';
import { getRuntimeSiteContext } from '../lib/siteContext';

export function useApexOnlyPage(path) {
  const siteContext = React.useMemo(() => getRuntimeSiteContext(), []);
  const shouldRedirect = siteContext.recognizedIslandHost && !siteContext.isApexHost;

  React.useEffect(() => {
    if (!shouldRedirect || typeof window === 'undefined') {
      return;
    }

    window.location.replace(buildApexCanonicalUrl(path));
  }, [path, shouldRedirect]);

  return shouldRedirect;
}
